const RightArrow = () => (
  <svg width='19px' height='11px' viewBox='0 0 19 11'>
    <defs />
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g transform='translate(-264.000000, -1008.000000)' fillRule='nonzero' fill='currentColor'>
        <g transform='translate(162, 1003)'>
          <polygon transform='translate(112, 11) rotate(90.000000) translate(-112, -11) ' points='111.006955 19.6084695 113.006955 19.6084695 113.006955 5.62200492 115.599405 8.49549165 117.084371 7.155761 112.006955 1.52792431 106.92954 7.155761 108.414505 8.49549165 111.006955 5.62200492' />
        </g>
      </g>
    </g>
  </svg>
)

export default RightArrow



// WEBPACK FOOTER //
// ./src/components/rightArrow/index.js